exports = module.exports = require("../../../../@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v-simple-checkbox{align-self:center;line-height:normal;position:relative;user-select:none}.v-simple-checkbox .v-icon{cursor:pointer}.v-simple-checkbox--disabled{cursor:default}", ""]);

// exports
